import React from 'react';
import { getDeviceName } from "../../../../../../Utils";

const Row = ({ affid, subid, device, country, spends, conversions, eCost }) => {
    return (
        <tr>
            <td>{affid}</td>
            <td>{subid}</td>
            <td>{getDeviceName(device)}</td>
            <td>{country}</td>
            <td>{spends}</td>
            <td>{conversions}</td>
            <td>{eCost}</td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderECost/components/PeriodTable/components/Row/index.js